/** A completed API attempt has usable endpoint output, not just a successful HTTP status. */
export function isCompletedTestResult(
  endpoint: string,
  status: number,
  payload: unknown
): boolean {
  if (status < 200 || status >= 300 || status === 202 || !payload || typeof payload !== "object") {
    return false;
  }

  const value = payload as Record<string, unknown>;
  if (value.error || ["queued", "pending", "running", "accepted"].includes(String(value.status))) {
    return false;
  }

  if (value.outcome === "no_face_detected" && Array.isArray(value.faces) && value.faces.length === 0) {
    return ["/verify", "/represent", "/compare"].includes(endpoint);
  }

  if (endpoint === "/verify") {
    return typeof value.verified === "boolean" &&
      typeof value.distance === "number" && Number.isFinite(value.distance) &&
      typeof value.threshold === "number" && Number.isFinite(value.threshold);
  }

  if (endpoint === "/represent") {
    const rows = Array.isArray(payload)
      ? payload
      : Array.isArray(value.result) ? value.result : [payload];
    return rows.length > 0 && rows.every((row) => {
      if (!row || typeof row !== "object") return false;
      const vector = row.embedding ?? row.vector;
      return Array.isArray(vector) && vector.length > 0 &&
        vector.every((entry: unknown) => typeof entry === "number" && Number.isFinite(entry));
    });
  }

  if (endpoint === "/compare") {
    return Array.isArray(value.results) && value.results.length > 0 &&
      value.results.every((row: unknown) => {
        if (!row || typeof row !== "object") return false;
        const distance = (row as Record<string, unknown>).distance;
        return typeof distance === "number" && Number.isFinite(distance);
      });
  }

  return false;
}
